let seaflora_play_banner_video_timeout = null;
let slider_banner_buttons = document.getElementsByClassName('slider-button');

if( slider_banner_buttons.length > 0 ) {
  for (var i = 0; i < slider_banner_buttons.length; i++) {
      slider_banner_buttons[i].addEventListener('click', seaflora_play_slider_videos, false);
  }
}

function seaflora_play_slider_videos() {
  let all_page_videos = document.getElementsByTagName('video');
  for (var v = 0; v < all_page_videos.length; v++) {
    
      all_page_videos[v].pause();
  }
  if( seaflora_play_banner_video_timeout ) {
    clearTimeout(seaflora_play_banner_video_timeout);
  }
  seaflora_play_banner_video_timeout = setTimeout( function() {
    let active_slide = document.querySelector('.slideshow__slide[aria-hidden="false"]');
    if( active_slide ) {
      let active_slide_video = active_slide.getElementsByTagName('video')[0];
      if( active_slide_video ) {
        active_slide_video.play();
      }
    }
  }, 1500);
  
}


